import { createContext } from 'react'

export type ErrorPageContextType = boolean

const ErrorPageContext = createContext<ErrorPageContextType>(true)

export default ErrorPageContext
